import { render, staticRenderFns } from "./FilesResume.vue?vue&type=template&id=122ce697&scoped=true&"
import script from "./FilesResume.vue?vue&type=script&lang=js&"
export * from "./FilesResume.vue?vue&type=script&lang=js&"
import style0 from "./FilesResume.vue?vue&type=style&index=0&id=122ce697&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122ce697",
  null
  
)

export default component.exports